<template>
    <div class="upload-facial-detail-wrapper" v-loading="loading">
        <div class="breadcrumb">导入记录详情
            <el-button class="right_f" type="primary" @click="goback">返回</el-button>
        </div>

        <div class="top-container">
            <div class="success-content">
                <img src="../../../assets/images/icon/icon_check_blue.png" alt="">
                <span>{{ '上传成功数量：' + (this.correctLine || '0') + '张' }}</span>
            </div>
            <div class="failure-content">
                <img src="../../../assets/images/icon/icon_cancel_red.png" alt="">
                <span>{{ '上传失败数量：' + (this.incorrectLine || '0') + '张' }}</span>
            </div>
            <el-button class="button-export" type="primary" @click="clickDownload">导出失败原因</el-button>
        </div>

        <div class="com-list">
            <el-table v-show="detailData.length > 0" :data="detailData">
                <el-table-column align="center" label="序号" type="id" width="80"></el-table-column>
                <el-table-column align="center" label="学生ID" prop="uid"></el-table-column>
                <el-table-column align="center" label="姓名" prop="name"></el-table-column>
                <el-table-column align="center" label="错误信息" prop="incorrectReason"></el-table-column>
            </el-table>
        </div>

        <el-pagination v-show="total > 0" layout="prev, pager, next" :page-size='pageSize' :total="total"
            :current-page="pageNum" @current-change="handleCurrentChange">
        </el-pagination>
    </div>
</template>

<script>
export default {
    data() {
        return {
            taskId: '',
            correctLine: '0',
            incorrectLine: '0',
            loading: false,
            dataInfo: {},
            detailData: [0],
            total: 0,
            pageNum: 1,
            pageSize: 20
        }
    },

    mounted() {
        this.taskId = this.$route.query.taskId;
        this.correctLine = this.$route.query.correctLine;
        this.incorrectLine = this.$route.query.incorrectLine;
        this.queryRecordDetail();
    },

    methods: {
        // 查询记录详情
        queryRecordDetail() {
            this.loading = true;
            this.$http({
                url: this.$util.domain + '/adminapi/redRank/upload/detail',
                method: 'POST',
                body: JSON.stringify({
                    taskId: this.taskId,
                    pageSize: this.pageSize,
                    pageNum: this.pageNum
                })
            }).then((res) => {
                if (res.data.error == 10000) {
                    this.dataInfo = res.data.data || {};
                    this.total = res.data.data.totalPages || 0;
                    this.detailData = res.data.data.content || [];
                } else {
                    this.dataInfo = {};
                    this.total = 0;
                    this.detailData = [];
                }
            }).catch((err) => {
                this.dataInfo = {};
                this.total = 0;
                this.detailData = [];
                this.$util.errorMsg('获取列表失败');
            }).finally(() => {
                this.loading = false;
            });
        },

        // 返回
        goback() {
            this.$router.go(-1);
        },

        //  点击导出
        clickDownload() {
            location.href = this.$util.domain + '/adminapi/redRank/upload/export?taskId=' + this.taskId
        },

        // 分页切换
        handleCurrentChange(val) {
            this.pageNum = val;
            this.queryRecordDetail();
        },
    }
}
</script>

<style scoped>
.upload-facial-detail-wrapper {
    display: block;
}

.top-container {
    padding: 0px 20px 20px 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.success-content {
    font-size: 16px;
    font-weight: 500;
    color: #405FFF;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.success-content img {
    width: 24px;
    height: 24px;
}

.failure-content {
    margin-left: 40px;
    font-size: 16px;
    font-weight: 500;
    color: #FF4444;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.failure-content img {
    width: 24px;
    height: 24px;
}

.button-export {
    margin-left: auto;
}
</style>


// WEBPACK FOOTER //
// UploadPhotoFacialDetail.vue?fa896816